var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.loading)?_c('div',{staticClass:"loader-wrapper"},[_c('div',{staticClass:"spinner spinner-1"})]):_vm._e(),_c('router-view'),_c('Overlay'),_c('Timeout')],1)}
var staticRenderFns = []

export { render, staticRenderFns }